import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0a9f151c")

_pushScopeId("data-v-0a9f151c")
const _hoisted_1 = {
  id: "search-flight-date-picker",
  class: "search-flight-date-picker flex flex-row items-center gap-2 flex-wrap w-full p-2 rounded-xl border border-gray-lp-3003 mb-3"
}
const _hoisted_2 = { class: "relative flex-1 min-w-0" }
const _hoisted_3 = {
  key: 0,
  class: "absolute top-0 left-0 z-10 bg-white py-0.5 px-2"
}
const _hoisted_4 = {
  key: 1,
  class: "absolute top-0 right-0 z-10 bg-white py-0.5 px-2"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_6 = {
  class: "absolute top-0 left-0 w-full h-full z-70",
  style: {"box-shadow":"rgba(33, 33, 33, 0.8) 0px 0px 1px 2px, rgba(33, 33, 33, 0.5) 0px 0px 0px 5000px","transform":"scaleX(1.1) scaleY(1.4)","border-radius":"10px"}
}
const _hoisted_7 = {
  class: "inline-flex w-4 h-4",
  style: {"color":"#ED1C24"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_DatePicker = _resolveComponent("DatePicker", true)!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.displayDates.length > 4)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode("div", {
              class: "flex rounded-full bg-gray-lp-1500 w-9 h-9 items-center justify-center pl-0.5 pb-0.5 cursor-pointer",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.scrollLeft && _ctx.scrollLeft(...args)))
            }, [
              _createVNode("div", null, [
                _createVNode(_component_Icons, {
                  name: "chevron-left",
                  class: "w-5"
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", {
        class: [
          'flex gap-2 flex-1 overflow-x-auto',
          _ctx.displayDates.length > 4
            ? 'overflow-x-auto whitespace-nowrap hide-scrollbar px-16'
            : 'flex-wrap'
        ],
        ref: "dateScroller"
      }, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.displayDates, (day) => {
          return (_openBlock(), _createBlock("button", {
            key: day.key,
            "data-date": day.key,
            type: "button",
            class: ["date-btn rounded-lg border py-2 text-sm font-bold transition-colors", [
            _ctx.isSelected(day.date) ? 'date-btn-selected' : 'date-btn-default',
            _ctx.displayDates.length > 4 ? 'max-w-350px' : 'flex-grow'
          ]],
            style: _ctx.displayDates.length > 4 ? { flex: '0 0 25%' } : {},
            onClick: ($event: any) => (_ctx.selectDate(day.date))
          }, _toDisplayString(_ctx.formatButtonLabel(day.date)), 15, ["data-date", "onClick"]))
        }), 128))
      ], 2),
      (_ctx.displayDates.length > 4)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode("div", {
              class: "flex rounded-full bg-gray-lp-1500 w-9 h-9 items-center justify-center pl-0.5 pb-0.5 cursor-pointer",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.scrollRight && _ctx.scrollRight(...args)))
            }, [
              _createVNode("div", null, [
                _createVNode(_component_Icons, {
                  name: "chevron-right-small",
                  class: "w-5"
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_5,
    (_ctx.showCalendar)
      ? (_openBlock(), _createBlock("button", {
          key: 0,
          type: "button",
          "data-testid": "cargo-search-flight-date-picker-calendar-toggle",
          class: "date-btn date-btn-other relative rounded-lg border py-3 text-sm font-bold flex items-center gap-1 justify-center w-44",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleCalendar && _ctx.toggleCalendar(...args)))
        }, [
          _withDirectives(_createVNode("div", _hoisted_6, null, 512), [
            [_vShow, _ctx.isOverlayVisible]
          ]),
          _createVNode("span", _hoisted_7, [
            _createVNode(_component_Icons, {
              name: "calendar-outlined",
              class: "w-full h-full"
            })
          ]),
          _createTextVNode(" " + _toDisplayString(_ctx.$t("cargo.v2.flight.search.date.selectOther")), 1)
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_OverlayPanel, {
      ref: "opCalendar",
      class: "search-flight-date-picker-overlay",
      id: "search-flight-date-picker-overlay"
    }, {
      default: _withId(() => [
        _createVNode("div", {
          class: "flex flex-col",
          onMouseenter: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isCursorInsideCalendar = true)),
          onMouseleave: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isCursorInsideCalendar = false))
        }, [
          _createVNode(_component_DatePicker, {
            ref: "picker",
            modelValue: _ctx.calendarDate,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.calendarDate = $event)),
            "is-range": false,
            class: "calendar-layout calendar",
            "min-date": _ctx.minCalendarDate,
            "max-date": _ctx.maxCalendarDate,
            "update-on-input": "",
            "from-page": _ctx.calendarPage
          }, null, 8, ["modelValue", "min-date", "max-date", "from-page"])
        ], 32)
      ]),
      _: 1
    }, 512), [
      [_vShow, _ctx.showCalendar]
    ])
  ]))
})